export default __webpack_public_path__ + "static/media/hammer.66d75cfc.svg";